import { IntegrationInitializationModal } from '../IntegrationInitializationModal'
import { IntegrationNotice } from '../IntegrationNotice'
import { useModals } from 'almanac-ui/Modal'
import Styles from '../IntegrationInitializationModal.module.scss'
import { Google } from 'blaze-ui/icons'
import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const GoogleAdsNotice = () => (
  <IntegrationNotice
    message={
      <div className={Styles.message}>
        To run and manage Google Ads campaigns, you need to connect your Google account with access to Google Ads.
        <br />
        <ul className={Styles.list}>
          <li>Sign in with the Google account linked to your Google Ads account</li>
          <li>Grant the required permissions when prompted</li>
        </ul>
      </div>
    }
  />
)

const GoogleAdsInitialization = ({ useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const sharedProps = {
    notice: <GoogleAdsNotice />,
    providerName: 'Google Ads',
    onClose: closeModal,
    icon: <Google size={32} />,
    title: 'Connect Google Ads Account',
    onConfirm: () => initiateOauth(ExternalIntegrationEnum.GoogleAds),
    primaryButtonText: 'Go to Google',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default GoogleAdsInitialization
